import React from 'react'
import RightBoxAuth from '../../global/RightBoxAuth'
import ForgetPassComp from './ForgetPassComp'
import { useTranslation } from 'react-i18next'

function AuthForgetPass() {
  const { t } = useTranslation()

  return (
    <>
      <div className="d-flex align-items-center">
        <RightBoxAuth title={t('auth.forgotPassword')} />
        <ForgetPassComp />
      </div>
    </>
  )
}

export default AuthForgetPass